import React, { useState } from 'react';

const Fact = ({ fact }) => (
  <div>
    <b className={fact.tone}>
      {fact.value.map((segment, index) => (
        <React.Fragment key={`${segment.text}-${index}`}>
          {index > 0 ? ' ' : null}
          {segment.tone ? <span className={segment.tone}>{segment.text}</span> : segment.text}
        </React.Fragment>
      ))}
    </b>
    <span>{fact.label}</span>
  </div>
);

const BulletList = ({ items }) => (
  <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul>
);

const IncidentSummary = ({ incident }) => (
  <div className="inc-summary">
    <p className="lead">{incident.lead}</p>
    <div className="inc-facts">
      {(incident.facts || []).map((fact) => <Fact fact={fact} key={fact.label} />)}
    </div>
    <BulletList items={incident.bullets || []} />
    {incident.extraTitle ? <p className="inc-extra"><strong>{incident.extraTitle}</strong></p> : null}
    {incident.extraBullets ? <BulletList items={incident.extraBullets} /> : null}
  </div>
);

/** Cards for Critical-priority cases, with the linked ServiceNow ticket where there is one. Summary only. */
export default function IncidentsView({ incidents }) {
  const list = Array.isArray(incidents) ? incidents : [];
  const [selected, setSelected] = useState(list[0] ? list[0].id : null);
  const incident = list.find((item) => item.id === selected) || list[0];
  if (!incident) {
    return (
      <section>
        <p className="note">No Critical-priority cases in this period.</p>
      </section>
    );
  }
  return (
    <section>
      <div className="inc-list" role="tablist" aria-label="Critical cases">
        {list.map((item) => (
          <button
            type="button"
            role="tab"
            className="inc-item"
            key={item.id}
            aria-selected={item.id === incident.id ? 'true' : 'false'}
            onClick={() => setSelected(item.id)}
          >
            <b>{item.title}</b>
            <span>{item.meta}</span>
          </button>
        ))}
      </div>
      <h2>Summary</h2>
      <IncidentSummary incident={incident} />
      <p className="note">Summary from Salesforce / ServiceNow — no separate write-up on file.</p>
    </section>
  );
}
